import { api_portalOfficeHospitalListing_responseFilter } from '@/init/swagger';
import { SearchHospitalsType } from '@/schemas/SearchParamsSchemas/app/stations/search/hospitals/Schema';
import { HOSPITAL_SEARCH_FILTER } from '@/types/types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

type Items = {
  id: number;
  label: string;
  checked: boolean;
};

type Props = {
  hospitalAppealPoints: api_portalOfficeHospitalListing_responseFilter[];
  search: () => Promise<void>;
  close: () => void;
};

export const useLogic = ({ hospitalAppealPoints, search, close }: Props) => {
  const { getValues, setValue: formSetValue } =
    useFormContext<SearchHospitalsType>();

  const filters =
    getValues('filters')?.filter(
      (v) => v.category_id === HOSPITAL_SEARCH_FILTER.APPEAL_POINT_CATEGORY_ID,
    ) ?? [];
  const initialItems = hospitalAppealPoints.map(({ id, label }) => ({
    id: id ?? NaN,
    label: label ?? '',
    checked:
      filters.find(({ search_filter_id }) => search_filter_id === id) != null,
  }));
  const [items, setItems] = useState<Items[]>(initialItems);

  /** チェック状態の切り替えを行う */
  const toggle = (event: React.ChangeEvent<HTMLInputElement>, id: number) => {
    const checked = event.target.checked;
    setItems(
      items.map((item) => (item.id === id ? { ...item, checked } : item)),
    );
  };

  const onClear = async () => {
    const currentFilters = getValues('filters') ?? [];
    const newFilters = currentFilters.filter(
      (v) => v.category_id !== HOSPITAL_SEARCH_FILTER.APPEAL_POINT_CATEGORY_ID,
    );
    formSetValue('filters', newFilters);

    await search();

    close();
  };

  const onSubmit = async () => {
    const currentFilters = getValues('filters') ?? [];
    const checkedFilters = items
      .filter((item) => item.checked)
      .map((item) => ({
        category_id: HOSPITAL_SEARCH_FILTER.APPEAL_POINT_CATEGORY_ID,
        search_filter_id: item.id,
      }));
    const newFilters = [
      ...currentFilters.filter(
        (v) =>
          v.category_id !== HOSPITAL_SEARCH_FILTER.APPEAL_POINT_CATEGORY_ID,
      ),
      ...checkedFilters,
    ];
    formSetValue('filters', newFilters);

    await search();

    close();
  };

  return {
    items,
    toggle,
    onClear,
    onSubmit,
  };
};
